export class GdsgBigtableTableCpu {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "table",
            "baseName": "table",
            "type": "string",
            "format": ""
        },
        {
            "name": "cpuLoad",
            "baseName": "cpuLoad",
            "type": "number",
            "format": "double"
        },
        {
            "name": "observedAtMs",
            "baseName": "observedAtMs",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return GdsgBigtableTableCpu.attributeTypeMap;
    }
    constructor() {
    }
}
